export default __webpack_public_path__ + "static/media/30.911c59cd.jpg";